import axios from "axios";
import { create } from "zustand";

export let useDiscount = create((set, get) => ({
    discounts: [],
    ed: {},
    setEd: (ed) => set({ ed }),
    columns: [
  
        {
            title: 'Id',
            dataIndex: 'id',
            key: 'id',
            width: 100,
        },
        {
            title: 'Kodi',
            dataIndex: 'code',
            key: 'code',
            width: 100,
        },
        {
            title: 'Turi',
            dataIndex: 'type',
            key: 'type',
            width: 100,
        },
        {
            title: 'Miqdor',
            dataIndex: 'amount',
            key: 'amount',
            width: 100,
        },
        {
            title: 'Muddati',
            dataIndex: 'limittime',
            key: 'limittime',
            width: 100,
        },
        {
            title: 'Yaratilgan',
            dataIndex: 'created_at',
            key: 'created_at',
            width: 100,
        },
    ],
    getDiscounts: () => {
        axios.get('/discount').then(res => {
            set({ discounts: res.data })
        })
    },
    addDiscount: (data) => {
        axios.post('/discount', data).then(res => {
            get().getDiscounts()
        })
    },
    updateDiscount: (data) => {
        axios.put('/discount/' + data.id, data).then(res => {
            get().getDiscounts()
        })
    },
    deleteDiscount: (id) => {
        axios.delete('/discount/' + id).then(res => {
            get().getDiscounts()
        })
    },
}))